<template>
  <editPassword/>
</template>

<script>
import editPassword from './components/editPassword'
export default {
  components: {
    editPassword
  },
  data () {
    return {
      breadCrumbs: [{
        label: '首页'
      }, {
        label: '个人中心'
      }]
    }
  }
}
</script>

<style lang="scss" scoped>
.myOwnOrder {
    width: 100%;
}
</style>
